module.exports = __webpack_public_path__ + "static/media/wanderer-bracelets-6.af156cae.jpg";